// TODO: remove when api is changed accordingly
export enum CommitteeDataTypeEnum {
  MATERIALS = '046529a8-1d4e-4e19-b2af-fa9be40815b8',
  TEST_QUESTIONS = '6770d09e-9ec8-4500-9a51-3d642dbc9d34',
  ANALYTICAL_INFORMATION = '811c443b-bdaa-4fa4-903c-0cf4f883ef64'
}
